<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
      :title="title"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
    <div class="gaugesubject_body">
      <div class="gaugesubject_body_title">
        <div class="gaugesubject_body_title_index">
          <span style="fontsize: 20px">{{ R_indx + 1 }}</span> /
          <span>{{ subject.length }}</span> 题
        </div>
        <div class="gaugesubject_body_title_btns">
          <div
            :class="index == R_indx ? 'subject_btn_b' : 'subject_btn_a'"
            v-for="(item, index) in subject"
            :key="index"
            :id="'over' + index"
            @click="btncilck(index, item)"
          >
            {{ item.sortCode }}
          </div>
        </div>
      </div>
      <div class="gaugesubject_body_subject">
        <subject
          :subjectlist="subject[R_indx]"
          :SR_idnex="-1"
          @getanswer="getanswer"
          ref="subject"
        ></subject>
      </div>
      <div class="foot_btns">
        <div class="btn_a">
          <van-button
            v-if="R_indx != 0"
            plain
            hairline
            type="info"
            block
            @click="lastsub"
            >上一题</van-button
          >
        </div>
        <div class="btn_b">
          <van-button
            type="info"
            block
            @click="insertmentaltestresult()"
            v-if="R_indx + 1 == subject.length"
            >提交</van-button
          >
          <van-button type="info" block @click="nextsub" v-else
            >下一题</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import backindex from "@/mixins/backindex";
import subject from "./components/subject.vue";
export default {
  mixins: [setOptions, backindex],
  data() {
    return {
      timer: null,
      pid: null,
      questionary: null,
      SR_index: null,
      R_indx: 0,
      radio: null,
      patientId: "",
      title: "焦虑状态调查",
     surveyId:"",
     subject:[]
    };
  },
  components: {
    Nav,
    subject,
  },
  created() {
    if (this.$route.query) {
      this.pid = this.$route.query.pid;
      this.questionary = this.$route.query.questionary;
      this.patientId = this.$route.query.patientId;
      this.title = this.$route.query.name;
      this.surveyId=this.$route.query.surveyId;
     
    }
    this.queryquestioninfobyid();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    async queryquestioninfobyid() {
      try {
        this.$showLoad();
        let url = "/gauge/queryquestioninfobyid";
        let data = {
          id: this.questionary,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            this.subject = data.data.data.data;
            this.subject.forEach((element) => {
              element["value"] = "";
              // console.log(element)
            });
          }
        );
      } catch (error) {}
    },
    async insertmentaltestresult() {
      let res = [];
      for (let x in this.subject) {
        if (!this.subject[x].value) {
          x = Number(x);
          this.$toast.fail(`第 ${x + 1} 题尚未选择答案`);
          return;
        } else {
          res.push(this.subject[x].value);
        }
      }
      console.log(res.toString());
      try {
        this.$showLoad();
        let url = "/gauge/querypdfbyid";
        let data = {
          id: `${this.patientId}_${this.surveyId}`,
          questionary: this.questionary,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            // console.log(data);
            if (data.data.data.data.result) {
              this.$toast.success("提交成功");
              this.timer = setTimeout(() => {
                this.$hideLoad();
                this.$router.push({
                  path: "/qrgaugelist",
                  query: {
                    clinicId: this.pid,
                    clientId:this.patientId,
                    surveyId:this.surveyId
                  },
                });
              }, 1000);
            } else {
              this.$toast.fail("提交失败,请稍后重试");
            }
          }
        );
      } catch (error) {}
    },
    lastsub() {
      // this.$refs.subject.R_idnex = null;
      this.R_indx--;
      if (!this.subject[this.R_indx].value) {
        this.$refs.subject.R_idnex = null;
      } else {
        this.$refs.subject.R_idnex = this.subject[this.R_indx].value;
      }

      document.getElementById("over" + this.R_indx).scrollIntoView(true);
    },
    nextsub() {
      if (this.R_indx == this.subject.length - 1) {
        return;
      }
      this.R_indx++;
      if (!this.subject[this.R_indx].value) {
        this.$refs.subject.R_idnex = null;
      } else {
        this.$refs.subject.R_idnex = this.subject[this.R_indx].value;
      }
      document.getElementById("over" + this.R_indx).scrollIntoView(true);
    },
    async getanswer(id, index, questionaryId, questionId) {
      if(!index){
        this.$toast.fail('未填写答案')
        return
      }
      this.subject.forEach((element) => {
        if (element.id == id) {
          element.value = index;
        }
      });
      try {
        this.$showLoad();
        let url = "/gauge/insertquestionresult";
        // alert("PID",this.patientId)
        // alert("surveyId",this.surveyId)
        let data = {
          patientId: `${this.patientId}_${this.surveyId}`,
          questionaryId: questionaryId,
          questionId: questionId,
          result: index,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
          }
        );
      } catch (error) {}
      // 这句很重要
    },
    btncilck(index, item) {
      if (!this.subject[index].value) {
        this.$refs.subject.R_idnex = null;
      } else {
        this.$refs.subject.R_idnex = this.subject[index].value;
      }
      document.getElementById("over" + index).scrollIntoView(true);

      this.R_indx = index;
    },
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },
    //
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background-color: white;
  font-family: "SimSun";
  .gaugesubject_body {
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-height: 100vh;
    .gaugesubject_body_title {
      background-color: #5b8df6;
      height: 15vh;
      .gaugesubject_body_title_index {
        color: white;
        line-height: 8vh;
        margin-left: 2vw;
        font-size: 15px;
      }
      .gaugesubject_body_title_btns {
        display: flex;
        height: 10vh;
        width: 95vw;
        overflow-x: auto;
        .subject_btn_a {
          min-width: 8vw;
          height: 5vh;
          border: 1px solid white;
          color: white;
          line-height: 5vh;
          text-align: center;
          margin-left: 3vw;
        }
        .subject_btn_b {
          min-width: 8vw;
          height: 5vh;
          border: 1px solid white;
          color: #5b8df6;
          background-color: white;
          line-height: 5vh;
          text-align: center;
          margin-left: 3vw;
        }
      }
    }
    .gaugesubject_body_subject {
      width: 100vw;
      height: 65vh;
    }
    .foot_btns {
      width: 100vw;
      max-height: 20vh;
      margin: 0px auto;
      display: flex;
      flex-direction: row;
      .btn_a {
        margin-left: 3vw;
        width: 45vw;
      }
      .btn_b {
        margin-left: 3vw;
        width: 45vw;
      }
    }
  }
}
</style>